import { createSlice } from "@reduxjs/toolkit";

import authService from "../../services/auth.service";
import { createApiCase } from "../../helpers/create.api.case";
import { createApiThunk } from "../../helpers/create.api.thunk";
import apiService from "../../services/api.service";

export const login = createApiThunk("login", authService.login);
export const sendOtp = createApiThunk("sendOtp", authService.sendOtp);
export const getBrandList = createApiThunk(
  "getBrandList",
  apiService.getBrandList,
);
export const getModelList = createApiThunk(
  "getModelList",
  apiService.getModelList,
);
export const getShowroomList = createApiThunk(
  "getShowroomList",
  apiService.getShowroomList,
);

export const initialData = {
  loginLoading: false,
  sendOtpLoading: false,
  categoryListLoading: false,

  brandList: [],
  modelList: {},
  showroomList: [],

  language: "en",
  fullSizeGallery: [],
  showroomLoading: false,
  isOpenFullSizeGallery: false,

  isOpenFullLoading: false,
};

const dataSlice = createSlice({
  name: "common",
  initialState: initialData,
  reducers: {
    getRole: (state) => {
      state.role = localStorage.getItem("role");
    },
    getToken: (state) => {
      state.token = localStorage.getItem("token");
    },
    getUserId: (state) => {
      state.userId = localStorage.getItem("user_id");
    },
    getUsername: (state) => {
      state.username = localStorage.getItem("username");
    },
    getLanguage: (state) => {
      state.language = localStorage.getItem("lang") || "en";
    },

    setFullSizeGallery: (state, action) => {
      state.fullSizeGallery = action.payload;
    },
    openFullSizeGallery: (state) => {
      state.isOpenFullSizeGallery = true;
    },
    closeFullSizeGallery: (state) => {
      state.isOpenFullSizeGallery = false;
    },
    closeFullLoading: (state) => {
      state.isOpenFullLoading = false;
    },
  },
  extraReducers: (builder) => {
    createApiCase(builder, login, {
      loading: "loginLoading",
    });
    createApiCase(builder, sendOtp, {
      loading: "sendOtpLoading",
    });
    createApiCase(builder, getBrandList, {
      loading: "brandLoading",
      fulfilled: (state, action) => {
        state.brandList = action.payload.data.aaData;
      },
    });
    createApiCase(builder, getModelList, {
      loading: "modelLoading",
      fulfilled: (state, action) => {
        const modelList = action.payload.data.aaData;
        const groupedData = modelList.reduce((acc, item) => {
          const { brand_name, name } = item;

          if (!acc[brand_name]) {
            acc[brand_name] = [];
          }

          acc[brand_name].push({
            value: name,
            label: name,
          });

          return acc;
        }, {});

        const groupedFilter = modelList.reduce((acc, item) => {
          const { brand_id, id, name } = item;

          if (!acc[brand_id]) {
            acc[brand_id] = [];
          }

          acc[brand_id].push({
            id: id,
            brand_id: brand_id,
            label: name,
          });

          return acc;
        }, {});

        // const sortedGroupedOptions = Object.values(groupedData).sort((a, b) =>
        //   a.label.localeCompare(b.label)
        // );

        state.modelList = groupedData;
        state.modelOption = groupedFilter;
      },
    });
    createApiCase(builder, getShowroomList, {
      loading: "showroomLoading",
      fulfilled: (state, action) => {
        state.showroomList = action.payload.data;
      },
    });
  },
});

export const {
  getRole,
  getToken,
  getUserId,
  getUsername,
  getLanguage,
  setFullSizeGallery,
  openFullSizeGallery,
  closeFullSizeGallery,
  openFullLoading,
  closeFullLoading,
} = dataSlice.actions;

export default dataSlice.reducer;
